import { UpdateStepTemplateRequestSchema, UpdateStepTemplateResponseSchema } from './update-step-template.schema';
/**
 * Update Step Template Endpoint Contract
 * Renames a step template or edits its description
 */ export const updateStepTemplateContract = {
    method: 'PATCH',
    path: '/api/v2/step-template/:id',
    description: 'Update name or description of a step template',
    requestSchema: UpdateStepTemplateRequestSchema,
    responseSchema: UpdateStepTemplateResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden',
            404: 'Step template not found'
        }
    }
};

//# sourceMappingURL=update-step-template.contract.js.map